export default __webpack_public_path__ + "static/shareImg-aa02a7c754778ad6db11e27650ae700d.jpg";